<template>
  <div>
    <div v-if="admins.length">
      <donut-modal-sections-title
        category="warn"
        title="Only account admins can set this up."
      />
      <div class="t">
        <p>You can ask one of the admins below to set it up for your team or request to be made an account admin.</p>
        <p class="m-tx1">
          Not sure what being an admin means?
          <a
            class="link"
            href="https://help.donut.ai/en/articles/6349350-admin-types-and-permissions"
            target="_blank"
          >
            Learn more about admin and permissions.
          </a>
        </p>
        <p class="m-tx1 bold">Donut admins:</p>
        <ul class="m-tx1">
          <li
            v-for="name in admins"
            :key="name"
          >
            <span class="m-hx1">•</span>{{ name }}
          </li>
        </ul>
      </div>
    </div>
    <div v-else>
      <donut-modal-sections-title
        category="warn"
        title="Your account needs a tweak to use this feature"
      />
      <div class="f-h">
        <donut-contact-support />
        <div class="t">&nbsp;for help enabling this for your account.</div>
      </div>
    </div>
    <donut-modal-sections-actions
      button-text="OK"
      :show-cancel="false"
    />
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';

const { state } = useStore();

const admins = computed(() => state.modal.data?.admins || []);

onMounted(() => {
  window.donut.track('Opened Contact Support To Upgrade Modal', {
    source: state.modal.data?.source,
    hasAdmins: !!admins.value.length,
  });
});
</script>
